// hooks/DownLoadExcel/EodReport.js

import { excel } from "../excel";


export const EodReport = ({ eodlist, showAlert, currentUser }) => {
    try {
        if (!eodlist || eodlist.length === 0) {
            showAlert?.("No EOD data available.")
            return;
        }

        const rows = eodlist.map(d => ({
            "Recent Update": d?.updatedAt ? new Date(d?.updatedAt).toLocaleString("en-GB") : "-",
            "Client": d?.client?.name ?? "-",
            "Client Manager (SPOC)": d?.spoc?.name ?? "-",
            "Reporting Manager": d?.reportingManager?.name ?? "-",
            "Reporting Teamlead": d?.reportingTeamLead?.name ?? "-",
            "SAN SPOC": d?.primaryRecruiter?.name ?? "-",
            "Submitted By": d?.submittedBy?.name ?? "-",
            "JobCode": d?.job?.jobCode ?? "-",
            "ClientJobCode": d?.job?.clientJobCode ?? "-",
            "Title": d?.job?.title ?? "-",
            "Location": d?.job?.location ?? "-",
            "Type": d?.job?.type ?? "-",
            "Skills": Array.isArray(d?.job?.skills) ? d.job.skills.join(" , ") : (d?.job?.skills ?? "-"),
            "Status": d?.job?.status ?? "-",
            "Candidate Name": d?.candidate?.name ?? "-",
            "Mobile": d?.candidate?.number ?? "-",
            "Email": d?.candidate?.email ?? "-",
            "Candidate Location": d?.candidate?.address ?? "-",
            "Experience": d?.candidate?.exp ?? "-",
            "Current Company": d?.candidate?.currentCompany ?? "-",
            "Current CTC": d?.candidate?.ctc ?? "-",
            "Expected CTC": d?.candidate?.expectedCtc ?? "-",
            "Notice Period": d?.candidate?.noticePeriod ?? "-",
            "Negotiable Notice Period": d?.candidate?.negotiableNoticePeriod ?? "-",
            "LWD": d?.candidate?.lwd ?? "-",
            "Profile Submitted On": d?.profileSubmittedOn ? new Date(d.profileSubmittedOn).toLocaleString("en-GB") : "-",
            "Recent Status": d?.recentStatus?.status ?? "-",
            "Status UpdatedOn": d?.recentStatus?.timestamp ?? "-",
            "Comment": d?.recentStatus?.comment ?? "-",
            "Sub category": d?.recentStatus?.subcategory ?? "-",
            "Job Schedule Date": d?.recentStatus?.scheduledDate ? new Date(d?.recentStatus?.scheduledDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }) : "-",
            "Date of Joining": d?.recentStatus?.doj ? new Date(d?.recentStatus?.doj).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }) : "-",
            "Offered CTC": d?.recentStatus?.offeredCtc ?? "-",
            "Employee Id": d?.recentStatus?.empId ?? "-"
        }));

        excel({ rows, showAlert, type: "Eod Report", currentUser })
         
        showAlert?.("Excel downloaded successfully.");
    } catch (err) {
        console.error("Error in Eod Report", err);
        showAlert?.("Error while generating Excel.");
    }
};
